import { vsingleton } from '@niknevis/vue-modules'
import { InputParams } from 'ziggy-js'
import { ZiggyService } from './ziggy'

@vsingleton()
export class Router {

  constructor(
    private readonly ziggy: ZiggyService
  ) {
  }

  route(name: string, params?: InputParams) {
    return this.ziggy.route(name, params)
  }
}
